import { text } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { Authorization } from "../../state/authAtoms";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { ShowTknsPanelAtom } from "../../state/tknsAtoms";
import { TopBarControl } from "../StyledControl";
import { useMetrics } from "../../hooks/useMetrics";
import { useTkns } from "../../hooks/useTkns";

function TknsControl() {
	// payments-production doesn't exist yet — hide the entry point there
	// (dev + staging keep it). Remove this gate when the prod worker ships.
	if (process.env.NODE_ENV === "production") return null;
	return <TknsControlInner />;
}

function TknsControlInner() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const setShowTkns = useSetRecoilState(ShowTknsPanelAtom);
	const isLoggedIn = useRecoilValue(Authorization).isLoggedIn;
	const { trackFeature } = useMetrics();
	const { refreshBalance } = useTkns();

	// Warm the balance once the user is logged in so the panel shows a number
	// instantly instead of the "—" placeholder while it fetches on open.
	useEffect(() => {
		if (isLoggedIn) refreshBalance();
	}, [isLoggedIn, refreshBalance]);

	const handleClick = () => {
		setShowTkns(true);
		trackFeature("tkns_panel");
	};

	return (
		<TopBarControl
			$isInPortrait={isInPortrait}
			data-testid="tkns-control"
			onClick={handleClick}
			onMouseOver={() => setTextHelper(text.tkns.title)}
			onMouseLeave={() => setTextHelper(undefined)}
			aria-label={text.tkns.title}
		>
			{text.tkns.title}
		</TopBarControl>
	);
}

export default TknsControl;
